export default __webpack_public_path__ + "static/media/home.84e8ecb9.svg";